import { __PRODUCTION__ } from "./__PRODUCTION__.js";
const prefix = "Invariant failed";
function invariant(condition, message) {
  if (condition) {
    return;
  }
  if (__PRODUCTION__) {
    throw new Error(prefix);
  }
  throw new Error(`${prefix}: ${message || ""}`);
}
export {
  invariant
};
//# sourceMappingURL=invariant.js.map
